<link href="https://fonts.googleapis.com/css?family=Libre+Baskerville" rel="stylesheet">

<div class="root">

    <!-- Login page uses the shared GM LoginComponent -->
    <ng-container *ngIf="page !== undefined && page !== null && page.PageID === 15">
        <app-login
            [form]="page.Form"
            [pageID]="this.pageID"
            [submitMessage]="page.SubmitMessage"
            (formSubmitted)="formValidAndSubmitted($event)">
        </app-login>
    </ng-container>
    
    <div class="container">
        <!-- This scrollbar is used to auto-scroll to the top of the screen on sumbit -->
        <div *ngIf="page !== undefined && page !== null && page.PageID != 15" #scrollContainer class="scroll" style="height: 100vh; width: 100%;">
            <div>
                <app-easysuite-loader *ngIf="pageLoading" [GUI_themeID]="themeID"></app-easysuite-loader>
            </div>
            <!-- $event is true when header is loaded due to headerDropdownsReady becoming true. -->
            <app-easysuite-header 
                [appID]="appID" 
                [navID]="navID"
                (headerDropdownsReady)="loadSideNavAndPageContent = $event"
                (appChangeRequested)="onAppChange($event)"
            ></app-easysuite-header>
            
            <ng-container *ngIf="loadSideNavAndPageContent || !auth.getToken()">
                <!-- The page, side-navs and top-navs are displayed when the dropdowns have already loaded or if there is no session token (the latter for pages without authentication such as the login) -->
                <app-easysuite-top-nav *ngIf="app.innerWidth > 990" [psuedoLoginInfo]="this.loginPageInfo"></app-easysuite-top-nav>
                <app-easysuite-mobile-nav *ngIf="app.innerWidth <= 990" [psuedoLoginInfo]="this.loginPageInfo"></app-easysuite-mobile-nav>
    
                <div *ngIf="this.page" class="content" style="padding:10px 0;background:#fff">
                    <div class="row">
                        <div class="col-md-3">
                            <app-easysuite-side-nav [psuedoLoginInfo]="this.loginPageInfo"></app-easysuite-side-nav>
                        </div>
                        <div class="col-md-9 change_padding">
                            <div class="border">
                                <div style="float:right">
                                    <span>
                                        <a (click)="triggerSupportLink()">Support</a>
                                    </span>
                                </div>

                                <!-- this.page is the js data object returned from V2 via this.content.getPage in the ngOnInit of the superstructure-base.component.ts -->
                                <div id="main_page">
                                    <table>
                                        <tr>
                                            <td>
                                                <p class="title">{{this.page.Title}}</p>
                                                <div *ngIf="page.SubmitMessage !== undefined" class="top_message">
                                                    <strong [innerHTML]="page.SubmitMessage">
                                                        {{page.SubmitMessage}}
                                                    </strong>
                                                </div>

                                                <!-- onLoad alerts: separate from the submit message, same look (inherits theme color) -->
                                                <div *ngIf="page.OnLoadMessage" class="top_message">
                                                    <strong [innerHTML]="page.OnLoadMessage"></strong>
                                                </div>
                                            </td>
                                        </tr>
                                    </table>
                                    <table id="page_description" *ngIf="this.page.Description">
                                        <tr>
                                            <td>
                                                <p id="main">                                        
                                                <span id="page_des_short" style="font-weight:500;"  [innerHTML]="this.page.Description"></span>
                                                <a *ngIf="!this.descriptionVisible && this.page.MoreDescription" (click)="toggleDescription()" id="page_a_more"> more...</a>
                                                <p id="page_des_more" *ngIf="this.descriptionVisible" [innerHTML]="this.page.MoreDescription"></p>

                                            <!-- This can be improved upon to use native Angular buttons like the way is done in easysuite-table.component.html. -->
                                            <p class="view_button" 
                                               *ngIf="objectKeys(page.Buttons).length > 0">                
                                                <span *ngFor="let buttonKey of objectKeys(page.Buttons)">
                                                    <input *ngIf="page.Buttons[buttonKey].Label" type="button" style="margin-right:4px"
                                                        [value]="page.Buttons[buttonKey].Label" class="btn btn-success"
                                                        (click)="handleButtonLink(page.Buttons[buttonKey].Type, page.Buttons[buttonKey].Label, page.Buttons[buttonKey].Link)">
                                                </span>
                                            </p>    
                                        </td>
                                    </tr>
                                </table>
                                <div class="viewform">
                                    <form>
                                        <app-easysuite-form *ngIf="this.page.Form" [form]="this.page.Form"
                                            [pageID]="this.pageID"
                                            (formSubmitted)="formValidAndSubmitted($event)"
                                            (pageAction)="handleActionResponse($event)">
                                        </app-easysuite-form>
                                    </form>
                                </div>
 
                                <div *ngIf="page.Table" class="table-container">
                                    <app-easysuite-table *ngIf="page.Table" [table]="page.Table"
                                        [reloadNotifier]="reloadTableSubject.asObservable()"
                                        (needsLoadingAnimation)="triggerLoading($event)"
                                        (pageAction)="handleActionResponse($event)"
                                        [pageID]="page.PageID"
                                        [reloadWithDataNotifier]="this.reloadTableWithDataSubject.asObservable()"></app-easysuite-table>
                                </div>
                                <div *ngIf="page.Chart">
                                    <app-easysuite-charts *ngIf="page.Chart" 
                                       [pageID]="page.PageID" 
                                       [chart]="page.Chart"
                                    ></app-easysuite-charts>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                </div>
            </div>
            </ng-container>
        </div>
    </div>
</div>